import React, {Component, useContext} from "react";
import {IAuthService} from "./services/auth-service";

export const AuthContext = React.createContext<IAuthService>(({} as any));

export const AuthConsumer = AuthContext.Consumer;
export const useAuthentication = () => {
    return useContext(AuthContext);
};

export class AuthProvider extends Component<{ authService: IAuthService }> {
    render() {
        return <AuthContext.Provider value={this.props.authService}>
            {this.props.children}
        </AuthContext.Provider>;
    }
}
